import { connect } from "react-redux";
import { UserPlusIcon } from "@heroicons/react/24/outline";
import React, { useState } from "react";
import Button from "src/components/Shared/Buttons/Button";
import Search from "src/components/Shared/Search";
import MultiColumnLayout from "src/components/Shared/MultiColumnLayout/MultiColumnLayout";
import UserDateTime from "src/components/Users/List/UserDateTime";
import UserItems from "src/components/Users/List/UserItems";
import UserBodyContent from "src/components/Users/List/UserBodyContent";
import UserAddModal from "src/components/Users/Modal/UserAddModal";
import useGetListAndSelectItem from "src/hooks/useGetListAndSelectItem";
import { apiRequest } from "src/async/apiUtils";
import { toast } from "react-toastify";
import Modal from "src/components/Shared/Modal";

const UsersList = ({ filterUserType = ["admin"], setSubTitle, user, ...props }) => {
  const [isManageModalOpen, setIsManageModalOpen] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [deleteModalIsOpen, setDeleteModalIsOpen] = useState(false);

  // status change & delete
  const [isDeleting, setIsDeleting] = useState(false);
  const [isTogglingStatus, setIsTogglingStatus] = useState(false);

  const { lists, meta, isLoaded, limit, offset, setOffset, keyword, setKeyword, selectedItem, setSelectedItem, handleOnPaginationChange, refreshData } = useGetListAndSelectItem({
    url: `/users`,
    paginationData: { limit: 10, offset: 0 },
    additionalQuery: { type: String(filterUserType) },
  });

  const onOpenEditModal = () => {
    setEditItem(selectedItem);
    setIsManageModalOpen(true);
  };

  const handleOnDelete = async () => {
    try {
      setIsDeleting(true);
      const { data } = await apiRequest("DELETE", `/users/:user_id`, { params: { user_id: selectedItem?._id } });
      setDeleteModalIsOpen(false);
      refreshData();
      toast.success(data.message);
    } catch (error) {
      toast.error(error.message);
    } finally {
      setIsDeleting(false);
    }
  };

  const handleToggleStatus = async () => {
    try {
      setIsTogglingStatus(true);
      const { data } = await apiRequest("PUT", `/users/${selectedItem?._id}/status`, {});
      setSelectedItem((prev) => ({
        ...prev,
        active_status: !prev.active_status,
      }));
      toast.success(data.message);
    } catch (error) {
      toast.error(error.message);
    } finally {
      setIsTogglingStatus(false);
    }
  };

  const headerActions = [
    ...(selectedItem?.default_user && !user?.default_user ? [] : [{ _id: 1, name: "Edit", onClick: onOpenEditModal }]),
    ...(!(user?._id === selectedItem?._id || selectedItem?.default_user)
      ? [
          { _id: 4, name: "", type: "hr" },
          { _id: 5, name: "Delete", onClick: () => setDeleteModalIsOpen(true) },
        ]
      : []),
  ];

  return (
    <>
      <MultiColumnLayout
        // title={"Admin List"}
        subTitle={`Total of ${meta?.count || 0} admins`}
        asideLoaded={isLoaded}
        aside={lists}
        paginationData={{ meta, limit, offset }}
        handleOnPaginationChange={handleOnPaginationChange}
        itemEntry={(item) => <UserItems data={item} />}
        selectedItem={selectedItem}
        setSelectedItem={setSelectedItem}
        mainHeaderContent={
          <>
            <div className="w-96">
              <Search
                keyword={keyword}
                setKeyword={(val) => {
                  setOffset(0);
                  setKeyword(val);
                }}
                placeholder={"Search"}
                inline={true}
              />
            </div>
            <div className="relative">
              <Button
                version="secondary"
                onClick={() => {
                  setIsManageModalOpen(true);
                  setEditItem(null);
                }}>
                <UserPlusIcon className="h-5 w-5" />
                Add admin
              </Button>
            </div>
          </>
        }
        bodyHeaderAdditionalContent={selectedItem?.last_login && <UserDateTime data={selectedItem} />}
        bodyHeaderActions={headerActions}
        bodyContent={
          <UserBodyContent
            data={selectedItem}
            onToggleStatus={handleToggleStatus}
            isTogglingStatus={isTogglingStatus}
            onEdit={() => {
              setEditItem(selectedItem);
              setIsManageModalOpen(true);
            }}
          />
        }
      />
      <UserAddModal
        isOpen={isManageModalOpen}
        onCancel={() => {
          setIsManageModalOpen(false);
        }}
        data={editItem}
        refreshData={refreshData}
        onSuccess={() => {
          setIsManageModalOpen(false);
        }}
      />
      <Modal
        title="Admin"
        secondaryTitle="Delete"
        isOpen={deleteModalIsOpen}
        onCancel={() => setDeleteModalIsOpen(false)}
        isLoading={isDeleting}
        onSuccess={handleOnDelete}
        defaultOptions={{
          onSuccessButtonText: "Delete",
        }}>
        <div className="flex flex-col gap-y-1 whitespace-nowrap px-3 py-6 text-gray-600">
          <p className="text-lg">
            Are you sure you want to <span className="px-1 font-semibold text-gray-700">DELETE</span>
            this admin?
          </p>
          <div className="text-gray-400">Once you delete this client it's gone for good.</div>
        </div>
      </Modal>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.auth.user,
    site: state.site,
  };
};

export default connect(mapStateToProps, {})(UsersList);
